import { render, staticRenderFns } from "./OperateDialog.vue?vue&type=template&id=57b57063&scoped=true"
import script from "./OperateDialog.vue?vue&type=script&lang=js"
export * from "./OperateDialog.vue?vue&type=script&lang=js"
import style0 from "./OperateDialog.vue?vue&type=style&index=0&id=57b57063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b57063",
  null
  
)

export default component.exports